import { Component } from '@angular/core';
import { Storage } from '@ionic/storage'; 

import { LoginPage } from '../pages/login/login';
import { DashboardPage } from '../pages/dashboard/dashboard';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  rootPage:any;

  storage : Storage;

  constructor(storage : Storage) {
    this.storage = storage;
    this.storage.ready().then(()=>{
      this.storage.get('x-access-token').then((token)=>{
        if(token) this.rootPage = DashboardPage;
        if(!token) this.rootPage = LoginPage;
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts